/**
 * Identifies the Bid Request message type.
 * tag: 374
 * @readonly
 * @enum {string} (char)
 */
export enum BidRequestTransType {
  /** Cancel */
  Cancel = 'C',
  /** New */
  New = 'N',
}
